import { cn } from "@/lib/cn";

// The building blocks a dialog lays its content out with, inside <Modal>

export const ModalHeader = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <header className={cn("mb-4 lg:mb-8", className)} {...props} />
);

export const ModalTitle = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h1 className={cn("text-center text-2xl font-medium leading-[1.17]", className)} {...props}>
    {children}
  </h1>
);

export const ModalContent = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <section className={cn("py-4 text-base leading-[1.4em]", className)} {...props} />
);

export const ModalParagraph = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn("mb-4 last:mb-0", className)} {...props} />
);

export const ModalFooter = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <footer className={cn("mt-6 flex justify-evenly gap-3", className)} {...props} />
);
